import { IColumnDefinition, ITable, ITableObject } from "@models/entity-models";
import { Utils } from "@tools";

export class Table implements ITable {
    constructor(o?: ITable) {
        if (o) {
            this.id = o.id;
            o.columns.forEach(c => {
                this.addColumn(c);
            });
            this.name = o.name;
            this.description = o.description;
            this.data = o.data;
        }
    }

    public id: number;
    public name: string;
    public description: string;
    public columns: IColumnDefinition[] = [];
    public data: any[][] = [[]];

    private _columnDb: { [name: string]: number } = {};

    /**
     * use this instead of pushing directly to columns array so that
     * the columnDb can be maintained for fast searching
     */
    public addColumn(col: IColumnDefinition) {
        this.columns.push(col);
        this._columnDb[col.name] = this.columns.length - 1;
    }

    // public addStandardColumns() {
    //    this.data = [[]];
    //    this.columns.clear();
    //    this.columns.pushArray([
    //        { name: "value", type: eColumnType.text },
    //        { name: "label", type: eColumnType.text },
    //        { name: "image", type: eColumnType.media }
    //    ]);
    // }

    public addRow(row: {}) {
        let rowArr = [];
        for (let col of this.columns) {
            rowArr.push(row[col.name]);
        }
        this.data.push(rowArr);
    }

    public getCell(rowIndex: number, colName: string) {
        return this.data[rowIndex][this._columnDb[colName]];
    }

    public toObjectArray(): ITableObject {
        let d = [];
        let columnScrubMap = {};
        this.columns.forEach((col, i) => {
            columnScrubMap[i] = Utils.scrubName(col.name);
        });
        this.data.forEach((row, r) => {
            let o = {};
            this.columns.forEach((col, c) => {
                o[columnScrubMap[c]] = row[c];
            });
            d.push(o);
        });
        return {
            columns: this.columns,
            data: d
        } as ITableObject;
    }

}
